import {Flex} from '/app/src/component';
import style from './style.css'
import React from 'react';

const OnStyle = (isSelected)=> ({
    className: style.LargeContainerStyle,
    shrink: 0,
    border: isSelected ? '3px solid #2ea2d2' : '3px solid transparent',
    hoverBorder: isSelected ? '3px solid #2ea2d2' : '3px solid #f0f0f0',
    borderRadius: '20px',
    vAlignContent: 'center',
    cursor: 'pointer'
})


export default ({current , index , onSelected}) => {
    const isSelected = current === index

    const OfflineRadioLabel = {
        lineHeight: '23px',
        fontSize: '24px',
        color: 'black',
        fontWeight: isSelected?'500':'300',
        basis: '15%'
    }
    return(
        <Flex  onClick={onSelected(index)} {...OnStyle(isSelected)}>
            <Flex {...OfflineRadioLabel} > På </Flex>
            <Flex fontSize='18px' grow>
                  Offlineformuläret visas och besökare kan lämna sina uppgifter samt ett meddelande.
            </Flex>
        </Flex>
    )
}



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/ClientChatSettings/OfflineSettings/_OnOption.js